import React from 'react';
import {
  FiClipboard,
  FiDollarSign,
  FiHome,
  FiSearch,
  FiCalendar,
  FiFileText,
  FiBook,
  FiSettings,
  FiArchive,
  FiBriefcase,
  FiFile,
  FiSmartphone,
} from 'react-icons/fi';
import { IoSchoolOutline } from 'react-icons/io5';
import { FaHeartbeat } from 'react-icons/fa';
import { Link } from 'react-router-dom';

interface StudentTool {
  icon: React.ReactNode;
  label: string;
  link: string;
  highlighted?: boolean;
  isInternal?: boolean;
}

const ContinuingStudents: React.FC = () => {
  const tools: StudentTool[] = [
    { icon: <FiClipboard size={35} />, label: 'My Checklist', link: '/checklist', isInternal: true },
    { icon: <FiDollarSign size={35} />, label: 'My Financial Aid', link: '/financial-aid', isInternal: true },
    { icon: <FiHome size={35} />, label: 'My Housing', link: '/housing', isInternal: true },
    { icon: <FiSearch size={35} />, label: 'My Registration', link: '/registration', isInternal: true },
    { icon: <FiCalendar size={35} />, label: 'Course Schedule', link: '/course-schedule', isInternal: true },
    { icon: <FiFileText size={35} />, label: 'My Bill', link: '/bill', isInternal: true },
    { icon: <FiArchive size={35} />, label: 'Electronic Student Refund', link: '/refund', isInternal: true },
    { icon: <IoSchoolOutline size={35} />, label: 'My Degree Path', link: '/degree-path', highlighted: true, isInternal: true },
    { icon: <FiBook size={35} />, label: 'My Student Record', link: '/student-record', isInternal: true },
    { icon: <FiSettings size={35} />, label: 'My Personal Info', link: '/personal-info', isInternal: true },
    { icon: <FiBriefcase size={35} />, label: 'My Graduate Admissions', link: '/grad-admissions', isInternal: true },
    { icon: <FiSmartphone size={35} />, label: 'Text Opt-In', link: '/text-opt-in', isInternal: true },
    { icon: <FiFile size={35} />, label: 'My 1098t', link: '/1098t', isInternal: true },
    { icon: <FaHeartbeat size={35} />, label: 'Health Portal', link: '/health', isInternal: true },
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-uc-navy font-header uppercase tracking-wide">
          For Continuing Students
        </h2>
        <button className="text-gray-600 hover:text-gray-800">
          <span className="text-2xl">−</span>
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-7 gap-4">
        {tools.map((tool, index) => {
          const content = (
            <>
              <div className="text-uc-gold mb-2 group-hover:scale-110 transition-transform">
                {tool.icon}
              </div>
              <span className="text-sm text-gray-700 text-center leading-tight">
                {tool.label}
              </span>
            </>
          );

          const className = `flex flex-col items-center p-4 rounded-lg hover:bg-gray-50 transition-colors group relative ${
            tool.highlighted ? 'ring-2 ring-red-500' : ''
          }`;

          return tool.isInternal ? (
            <Link key={index} to={tool.link} className={className}>
              {content}
            </Link>
          ) : (
            <a key={index} href={tool.link} className={className}>
              {content}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default ContinuingStudents;
